import List from '../views/gallery/list'

export default [
    {
        path: '/admin/domain/:domain_id/gallery',
        name: 'gallery',
        component: List,
    }
]
